import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import HelmetWrapper from "../../HelmetWrapper";
// import CommonStructured from "../../components/common-components/CommonStructured";
import { selectAuth } from "../../components/auth/auth.selector";
import { fetchTestimonialData } from "../../redux/website-reducers/websiteSlice";
import AllTestimonial from "../../components/website-contents/testimonial/AllTestimonial";
import MealsStructure from "../../components/diet/meal/MealsStructure";
import SearchNButtons from "../../components/common-components/SearchNButtons";

const Testimonial = () => {
  const dispatch = useDispatch();
  const authData = useSelector(selectAuth);
  const userInfoData = authData.user;

  const iniModvalues = {
    isModOpen: false,
    cardName: "",
  };
  const [modValues, setModValues] = useState(iniModvalues);
  const [isPage, setIsPage] = useState(0);
  const iniAllFilter = {
    searchString: "",
    isActive: "",
    selCategory: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    limit: 10,
    page: isPage + 1,
    status: allFilters.isActive?.value || "",
    category: allFilters.selCategory?.value || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);

  // function onResetFilters() {
  //   setAllFilters(iniAllFilter);
  //   setFilters(iniFilters);
  //   setSearchFilterApplied(false);
  //   setIsPage(0);
  // }

  function onCloseModalvalues() {
    setModValues(iniModvalues);
  }

  const onClickSearch = () => {
    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
      setIsPage(0);
    }
  };

  function getTestimonial(filters) {
    dispatch(
      fetchTestimonialData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      status: allFilters.isActive?.value || "",
      category: allFilters.selCategory?.value || "",
    }));
  }, [isPage, allFilters.isActive, allFilters.selCategory]);

  useEffect(() => {
    getTestimonial(filters);
  }, [filters]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  return (
    <HelmetWrapper title="WTF: Vibe AT WTF">
      <Container className="bg-cloud-k px-50px" fluid>
        <Row>
          <Col>
            <MealsStructure text={"Testimonial"} />
          </Col>
        </Row>

        <br />

        <Row>
          <Col>
            <SearchNButtons
              pageName={"testimonial"}
              filters={allFilters}
              setFilters={setAllFilters}
              searchFilterApplied={searchFilterApplied}
              onClickSearch={onClickSearch}
              btnText={"+ Add new"}
              onClickAdd={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  cardName: "add",
                }))
              }
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <AllTestimonial
              isPage={isPage}
              setIsPage={setIsPage}
              callFunction={() => {
                getTestimonial(filters);
              }}
              userInfoData={userInfoData}
              modValues={modValues}
              setModValues={setModValues}
              onCloseModalvalues={onCloseModalvalues}
            />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default Testimonial;
